const {highlight} = instantsearch;

const search = instantsearch({
    indexName: 'web_lborg_dev',
    searchClient: algoliasearch(
        'EK04BNHENS',
        'fb66564ef6d7bcbfc4b8fbeb690c1e03'
    ),
    searchFunction(helper) {
        const resultsWrapper = document.querySelector('#ais-search-results-wrapper');
        resultsWrapper.style.display = helper.state.query === '' ? 'none' : '';
        
        // Remove any duplicate hits containers before searching
        const hitsContainers = document.querySelectorAll('#ais-hits-wrapper > .ais-Hits');
        if (hitsContainers.length > 1) {
            Array.from(hitsContainers).slice(1).forEach(container => container.remove());
        }
        
        if (helper.state.query) {
            helper.search();
        }
    },
});

search.on('render', function () {
    addHoverEffectToHits();
    
    // Remove any duplicate hits containers after rendering
    const hitsContainers = document.querySelectorAll('#ais-hits-wrapper > .ais-Hits');
    if (hitsContainers.length > 1) {
        Array.from(hitsContainers).slice(1).forEach(container => container.remove());
    }
});

search.on('reset', function() {
    const searchInput = document.querySelector('#ais-search-box input');
    if (searchInput) {
        searchInput.value = '';
    }
});

search.addWidgets([
    instantsearch.widgets.configure({
        hitsPerPage: 100,
    }),
    instantsearch.widgets.searchBox({
        container: '#ais-search-box',
        placeholder: 'Search...',
        autofocus: true,
        searchAsYouType: true,
        showSubmit: false,
        showLoadingIndicator: false,
        cssClasses: {
            root: 'search__box',
            form: 'box__form',
            reset: 'box__reset',
            input: 'box__input',
        },
        templates: {
            reset({cssClasses}, {html}) {
                return html`
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
							<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
						</svg>`;
            },
        },
        queryHook(query, search) {
            // Clear the hits wrapper before each new search
            const hitsWrapper = document.querySelector('#ais-hits-wrapper');
            if (hitsWrapper) {
                hitsWrapper.innerHTML = '';
            }
            search(query);
        },
    }),
    instantsearch.widgets.refinementList({
        container: '#ais-refinement-list',
        attribute: 'content_type',
        limit: 5,
        cssClasses: {
            root: 'search__refinement-list',
            list: 'refinement-list__list',
            item: 'refinement-list__item',
        },
        templates: {
            item(item, {html}) {
                const {label, count, isRefined, cssClasses} = item;
                const value = label.toLowerCase().replace(/\s/g, '-');
                return html`
						<button id="${value}" class="refinement-list__button ${isRefined ? 'refinement-list__button-active' : ''}">
							${label}
						</button>
                    `;
            },
        },

    }),
    instantsearch.widgets.hits({
        container: '#ais-hits-wrapper',
        cssClasses: {
            root: ['ais-Hits', 'search__hits'],
            list: ['ais-Hits-list', 'hits__list'],
            item: ['ais-Hits-item', 'hits__item']
        },
        templates: {
            empty(results, {html}) {
                return html`
                    <div class="hits__no-results">
                        <div class="hits__no-results-icon">
                            <div class="hits__no-results-icon-inner">😔</div>
                        </div>
                        <div class="hits__no-results-text">
                            <h3>No search results found</h3>
                            <p>
                                <span class="hits__no-results-search-query">"${results.query}"</span> did not match any resources currently at Loadbalancer.org. Please try again or <a href="/contact">Talk to us</a></p>
                        </div>
                    </div>
                `;
            },
            item(hit, {html, components}) {
                let image;
                let imageClass;
                let excerptClass;

                if (hit.excerpt) {
                    hit.excerpt = html`<p>${hit.excerpt}</p>`;
                    excerptClass = 'hits__content-excerpt';
                }

                if (hit.image) {
                    image = html`
							<div class="hits__image-wrapper">
								<div class="hits__image" style="background-image:url('${hit.image}')"></div>
							</div>`;
                    imageClass = 'hits__content-image';
                } else {
                    image = html`
							<div class="hits__icon-wrapper"></div>`;
                    imageClass = 'hits__content-icon';
                }
                const isPDF = hit.url.endsWith('.pdf');
                const isBlog = hit.original_type === 'blog';

                function openInBackground(e) {
                    e.preventDefault();
                    if (isPDF || isBlog) {
                        window.open(hit.url, '_blank', 'noopener');
                    } else {
                        window.location.href = hit.url;
                    }
                }

                // Handle docs or manuals case
                if (hit.original_type === 'docs' || hit.original_type === 'manuals') {
                    return html`
							<article class="hits__article hits__docs">
								<a id="${hit.objectID}" class="hits__link" href="${hit.url}" onclick="${openInBackground}">
									<div class="hits__content-wrapper ${excerptClass}">
										<div class="hits__icon-wrapper"></div>
										<div class="hits__content">
											<h2>${components.Highlight({attribute: 'title', hit})}</h2>
										</div>
									</div>
									<div class="hits__submit search__keys">
										<span>Select</span>
										<button type="button" class="search__button" data-bs-dismiss="modal" aria-label="Close"></button>
									</div>
								</a>
							</article>`;
                }
                // Handle other cases
                return html`
						<article class="hits__article hits__${hit.original_type}">
							<a id="${hit.objectID}" class="hits__link" href="${hit.url}" onclick="${openInBackground}">
								<div class="hits__content-wrapper ${imageClass} ${excerptClass}">
									${image}
									<div class="hits__content">
										<h2>${components.Highlight({attribute: 'title', hit})}</h2>
										${hit.excerpt}
									</div>
								</div>
								<div class="hits__submit search__keys">
									<span>Select</span>
									<button type="button" class="search__button" data-bs-dismiss="modal" aria-label="Close"></button>
								</div>
							</a>
						</article>`;
            }
        },
    }),

]);

search.start();

document.addEventListener('keydown', function (event) {
    navigationHandler(event);
});

const searchButtons = document.querySelectorAll('.search__button.search__button-icon');
searchButtons.forEach(button => {
    button.addEventListener('click', function () {
        if (button.classList.contains('search__navigate-up')) {
            navigationHandler({
                key: 'ArrowUp', preventDefault: () => {
                }
            });
        }
        if (button.classList.contains('search__navigate-down')) {
            navigationHandler({
                key: 'ArrowDown', preventDefault: () => {
                }
            });
        }
    });
});

function navigationHandler(event) {
    const searchModal = document.querySelector('.search__modal');
    const listItems = document.querySelectorAll('.search__modal.show #ais-hits-wrapper li');

    if (searchModal && searchModal.classList.contains('show') && listItems.length > 0) {
        let activeIndex = -1;

        // Find the currently active or focused item (if any)
        listItems.forEach((item, index) => {
            if (item.querySelector('.hits__link').classList.contains('active')) {
                activeIndex = index;
            }
        });

        // Handle ArrowDown navigation
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            if (activeIndex < listItems.length - 1) {
                // Remove 'active' class from the current item
                if (activeIndex >= 0) {
                    listItems[activeIndex].querySelector('.hits__link').classList.remove('active');
                }
                // Move to the next item (or start from the first if none is active)
                const nextItem = listItems[activeIndex + 1] || listItems[0];
                nextItem.querySelector('.hits__link').classList.add('active');
                nextItem.querySelector('.hits__link').focus(); // Focus on the next item
            }
        }
        // Handle ArrowUp navigation
        else if (event.key === 'ArrowUp') {
            event.preventDefault();
            if (activeIndex > 0) {
                // Remove 'active' class from the current item
                listItems[activeIndex].querySelector('.hits__link').classList.remove('active');
                // Move to the previous item (or start from the last if none is active)
                const prevItem = listItems[activeIndex - 1] || listItems[listItems.length - 1];
                prevItem.querySelector('.hits__link').classList.add('active');
                prevItem.querySelector('.hits__link').focus(); // Focus on the previous item
            }
        }
    }
}

function addHoverEffectToHits() {
    const listItems = document.querySelectorAll('#ais-hits-wrapper li .hits__link');  // Select the result links
    listItems.forEach(item => {
        item.addEventListener('mouseover', function () {
            listItems.forEach(link => link.classList.remove('active'));
            item.classList.add('active');
        });
        item.addEventListener('mouseout', function () {
            item.classList.remove('active');
        });
    });
}

$('#search-modal').on('shown.bs.modal', function () {
    const searchInput = document.querySelector('#ais-search-box input');
    if (searchInput) {
        searchInput.focus();
    }
});
$('#search-modal').on('hidden.bs.modal', function () {
    const resetButton = document.querySelector('.ais-SearchBox-reset');
    if (resetButton) {
        resetButton.click();
    }
});

// Add event listener for enter key
document.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
        const searchInput = document.querySelector('#ais-search-box input');
        if (searchInput && document.activeElement === searchInput) {
            event.preventDefault();
            // Remove any duplicate hits containers
            const hitsContainers = document.querySelectorAll('#ais-hits-wrapper > .ais-Hits');
            if (hitsContainers.length > 1) {
                Array.from(hitsContainers).slice(1).forEach(container => container.remove());
            }
        }
    }
});
